/* ════════════════════════════════════
   HYTZ — Homepage JS
   ════════════════════════════════════ */

// Scroll restoration: let browser preserve position on refresh (Sol pref 2026-04-23)
// (previously forced scrollRestoration='manual' + scrollTo(0,0) — removed)

// Product data
const hytzProducts = {
  'sauce-shield': { name:'Sauce Shield', substance:'Alcohol', for:'For Alcohol', color:'#95192d', caps:'3 capsules', timing:'Best taken before drinking. Also effective after. Take all 3 capsules with water.', desc:'Expertly formulated hangover reduction capsules with DHM, Milk Thistle, and 13 vitamins & extracts. Supports healthy liver function and metabolism of toxins so you can wake up feeling human.', img:'sauce-shield-bag-front.png', url:'/products/sauce-shield', variants:{single:'47877132714229',three:'47877134352629',dispenser:'47877134385397'}, suppFacts:{serving:'3 Capsules',container:'1',facts:[{name:'Thiamin (Vitamin B1)',amount:'2 mg',dv:'167%'},{name:'Riboflavin (Vitamin B2)',amount:'2000 mcg',dv:'154%'},{name:'Niacinamide',amount:'24 mg',dv:'150%'},{name:'Vitamin B6',amount:'15 mg',dv:'882%'},{name:'Folic Acid',amount:'200 mcg DFE',dv:'50%'},{name:'Vitamin B12',amount:'30 mcg',dv:'1250%'},{name:'Pantothenic Acid',amount:'6 mg',dv:'120%'},{name:'Zinc',amount:'3 mg',dv:'27%'},{name:'DHM (Dihydromyricetin)',amount:'450 mg',dv:'*'},{name:'Ginger Root Extract',amount:'450 mg',dv:'*'},{name:'Turmeric Extract',amount:'350 mg',dv:'*'},{name:'Ginseng Extract',amount:'150 mg',dv:'*'},{name:'Milk Thistle Extract',amount:'88 mg',dv:'*'},{name:'Prickly Pear Extract',amount:'75 mg',dv:'*'},{name:'Berberine HCl',amount:'20 mg',dv:'*'}]} },
  'lung-hero': { name:'Lung Hero', substance:'Smoking', for:'For Smoking & Vaping', color:'#4cb968', caps:'4 capsules', timing:'Can be taken daily. Take 4 capsules with water to start your road to recovery.', desc:'An expertly formulated blend of vitamins and nutrients to support respiratory wellness. Vitamin D3 for healthy lung function, Elderberry for immune support, and Mullein extract to promote fresh lung mucus development.', img:'lung-hero-bag-front.png', url:'/products/lung-hero', variants:{single:'47877135302901',three:'47877135859957',dispenser:'47877135892725'}, suppFacts:{serving:'4 Capsules',container:'1',facts:[{name:'Vitamin D',amount:'5 mcg',dv:'25%'},{name:'Mullein Extract',amount:'800 mg',dv:'*'},{name:'Elderberry Extract',amount:'400 mg',dv:'*'},{name:'Marshmallow Extract',amount:'300 mg',dv:'*'},{name:'Astragalus Extract',amount:'200 mg',dv:'*'},{name:'Maritime Pine Bark Extract',amount:'160 mg',dv:'*'},{name:'Tangerine Peel Extract',amount:'100 mg',dv:'*'},{name:'N-Acetylcysteine (NAC)',amount:'96 mg',dv:'*'},{name:'Licorice Extract',amount:'40 mg',dv:'*'}]} },
  'the-nod': { name:'The Nod', substance:'Opiates', for:'For Opiates & Kratom', color:'#764099', caps:'2 capsules', timing:'Take after use. 2 capsules with water to support gut health and promote alertness.', desc:'Recovery and replenish capsules with gut stimulants, L-Theanine, and targeted vitamins. Supports gut health while promoting energy and alertness when you need it most.', img:'the-nod-bag-front.png', url:'/products/the-nod', variants:{single:'47877135958261',three:'47877137367285',dispenser:'47877137400053'}, suppFacts:{serving:'2 Capsules',container:'1',facts:[{name:'Vitamin C',amount:'480 mg',dv:'533%'},{name:'Magnesium',amount:'37 mg',dv:'9%'},{name:'L-Theanine',amount:'105 mg',dv:'*'},{name:'Cascara Sagrada Extract',amount:'100 mg',dv:'*'},{name:'Aloe Vera',amount:'55 mg',dv:'*'},{name:'Green Tea Extract',amount:'40 mg',dv:'*'},{name:'Chicory Root',amount:'30 mg',dv:'*'},{name:'Senna Leaf',amount:'2 mg',dv:'*'}]} },
  'ski-gear': { name:'Ski Gear', substance:'Cocaine', for:'For Stimulants', color:'#83d0d3', caps:'2 capsules', timing:'Take after use. 2 capsules with water to support recovery and replenishment.', desc:'After-stimulant recovery capsules with 5-HTP, neuro support, and targeted extracts. Promotes immune system function and supports healthy brain function for a smoother comedown.', img:'ski-gear-bag-front.png', url:'/products/ski-gear', variants:{single:'47877137465589',three:'47877138186485',dispenser:'47877138219253'}, suppFacts:{serving:'2 Capsules',container:'1',facts:[{name:'Vitamin C',amount:'310 mg',dv:'344%'},{name:'Vitamin E',amount:'80 mg',dv:'533%'},{name:'Magnesium',amount:'26 mg',dv:'6%'},{name:'Alpha Lipoic Acid (ALA)',amount:'172 mg',dv:'*'},{name:'Acetyl-L-Carnitine (ALCAR)',amount:'143 mg',dv:'*'},{name:'5-Hydroxytryptophan (5-HTP)',amount:'100 mg',dv:'*'},{name:'Bromelain',amount:'32 mg',dv:'*'},{name:'CoEnzyme Q10 (CoQ10)',amount:'29 mg',dv:'*'}]} },
  'the-whip': { name:'The Whip', substance:'Nitrous', for:'For Nitrous', color:'#2b9dd8', caps:'2 capsules', timing:'Take after use plus a few days following. 2 capsules with water to replenish and protect.', desc:'Recovery capsules with high-dose Vitamin B12, neuro support, and 4 targeted vitamins & extracts. Maintains neural structures and replenishes essential vitamins that get depleted.', img:'the-whip-bag-front.png', url:'/products/the-whip', variants:{single:'47877138284789',three:'47877138972917',dispenser:'47877139005685'}, suppFacts:{serving:'2 Capsules',container:'1',facts:[{name:'Vitamin A',amount:'750 mcg RAE',dv:'83%'},{name:'Vitamin C',amount:'390 mg',dv:'433%'},{name:'Vitamin D',amount:'5 mcg',dv:'25%'},{name:'Vitamin E',amount:'80 mg',dv:'533%'},{name:'Vitamin B12',amount:'1600 mcg',dv:'66667%'},{name:'Magnesium',amount:'46 mg',dv:'11%'},{name:'Alpha Lipoic Acid (ALA)',amount:'100 mg',dv:'*'},{name:'Acetyl-L-Carnitine (ALCAR)',amount:'100 mg',dv:'*'},{name:'CoEnzyme Q10 (CoQ10)',amount:'25 mg',dv:'*'}]} },
  'roll-patrol': { name:'Roll Patrol', substance:'MDMA', for:'For MDMA', color:'#eb088c', caps:'2 capsules', timing:'Take after use. 2 capsules with water to support mood balance and recovery.', desc:'After-party recovery capsules with 5-HTP, Magnesium, and 6 targeted vitamins & extracts. Supports healthy hormone balance, mood, focus, and jaw relaxation.', img:'roll-patrol-bag-front.png', url:'/products/roll-patrol', variants:{single:'47877139136757',three:'47877139726581',dispenser:'47877139759349'}, suppFacts:{serving:'2 Capsules',container:'1',facts:[{name:'Vitamin C',amount:'210 mg',dv:'233%'},{name:'Vitamin E',amount:'50 mg',dv:'333%'},{name:'Magnesium',amount:'43 mg',dv:'10%'},{name:'Alpha Lipoic Acid (ALA)',amount:'172 mg',dv:'*'},{name:'Acetyl-L-Carnitine (ALCAR)',amount:'143 mg',dv:'*'},{name:'5-Hydroxytryptophan (5-HTP)',amount:'100 mg',dv:'*'},{name:'CoEnzyme Q10 (CoQ10)',amount:'30 mg',dv:'*'},{name:'Green Tea Extract (EGCG)',amount:'30 mg',dv:'*'}]} }
};

// Modal
const hytzModal = document.getElementById('hytz-modal');
if (hytzModal) {
  function hytzOpenModal(key) {
    const p = hytzProducts[key]; if (!p) return;
    const panel = document.getElementById('hytz-modal-panel');
    const imgEl = document.getElementById('hytz-modal-img');
    panel.style.setProperty('--modal-c', p.color);
    document.getElementById('hytz-modal-name').textContent = p.name;
    var modalPriceEl = document.getElementById('hytz-modal-price');
    if (modalPriceEl) modalPriceEl.textContent = '$4.99';
    document.getElementById('hytz-modal-desc').textContent = p.desc;
    var timingEl = document.getElementById('hytz-modal-timing');
    if (timingEl) timingEl.textContent = p.timing;
    // Product images — bag (single), box (3-pack), shipper (25-pack)
    var bagUrl = (window.hytzAssetUrls && window.hytzAssetUrls[p.img]) || p.img;
    var boxUrl = (window.hytzBoxUrls && window.hytzBoxUrls[key]) || bagUrl;
    var shipperUrl = (window.hytzShipperUrls && window.hytzShipperUrls[key]) || bagUrl;
    window._hytzModalImages = { single: bagUrl, three: boxUrl, dispenser: shipperUrl };
    imgEl.innerHTML = '<img src="' + bagUrl + '" alt="' + p.name + '">';

    // Image selector tabs
    var imgSelector = document.getElementById('hytz-modal-img-selector');
    if (imgSelector) {
      imgSelector.innerHTML = '<button class="hytz-modal-img-tab active" data-size="single">Single</button>' +
        '<button class="hytz-modal-img-tab" data-size="three">3-Pack</button>' +
        '<button class="hytz-modal-img-tab" data-size="dispenser">25-Pack</button>';
    }

    // Set variant IDs by index — Single, 3-Pack, 25-Pack
    if (p.variants) {
      var modalPills = document.querySelectorAll('#hytz-modal-variants .hytz-modal-price-pill');
      if (modalPills[0]) modalPills[0].dataset.variantId = p.variants.single;
      if (modalPills[1]) modalPills[1].dataset.variantId = p.variants.three;
      if (modalPills[2]) modalPills[2].dataset.variantId = p.variants.dispenser;
    }
    // Supplement facts — styled HTML
    var suppFactsEl = document.getElementById('hytz-modal-supp-facts');
    if (suppFactsEl && p.suppFacts) {
      var sf = p.suppFacts;
      var html = '<div class="hytz-supp-panel">';
      html += '<div class="hytz-supp-serving">Serving Size: ' + sf.serving + '</div>';
      html += '<div class="hytz-supp-divider-thick"></div>';
      html += '<div class="hytz-supp-row hytz-supp-row-header"><span>Amount Per Serving</span><span>% DV</span></div>';
      html += '<div class="hytz-supp-divider"></div>';
      sf.facts.forEach(function(f) {
        html += '<div class="hytz-supp-row"><span>' + f.name + ' <strong>' + f.amount + '</strong></span><span>' + f.dv + '</span></div>';
        html += '<div class="hytz-supp-divider"></div>';
      });
      html += '<div class="hytz-supp-footnote">* Daily Value not established.</div>';
      html += '</div>';
      suppFactsEl.innerHTML = html;
    }
    // Reset accordions
    document.querySelectorAll('.hytz-modal-accordion.active').forEach(function(a) { a.classList.remove('active'); });
    hytzModal.classList.add('active');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.body.style.touchAction = 'none';
  }
  function hytzCloseModal() {
    hytzModal.classList.remove('active');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.touchAction = '';
  }
  document.getElementById('hytz-modal-close').addEventListener('click', hytzCloseModal);
  hytzModal.addEventListener('click', function(e) { if (e.target === hytzModal) hytzCloseModal(); });
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') hytzCloseModal(); });
  document.querySelectorAll('[data-hytz-modal]').forEach(function(c) {
    c.addEventListener('click', function(e) {
      if (!e.target.closest('.hytz-lineup-row-price') && !e.target.closest('.hytz-lineup-row-atc-label')) {
        hytzOpenModal(c.dataset.hytzModal);
      }
    });
  });
}

// Nav scroll
const hytzNav = document.getElementById('hytz-nav');
if (hytzNav) {
  window.addEventListener('scroll', function() {
    hytzNav.classList.toggle('scrolled', window.scrollY > 20);
    if (hytzCartDrawer && hytzCartDrawer.classList.contains('active')) hytzPositionCart();
  }, { passive: true });
}

// Mobile menu
var hytzHamburger = document.querySelector('.hytz-nav-hamburger');
var hytzMobileMenu = document.getElementById('hytz-mobile-menu');
var hytzMobileOverlay = document.getElementById('hytz-mobile-menu-overlay');

function hytzPositionMenu() {
  if (!hytzMobileMenu || !hytzNav) return;
  var rect = hytzNav.getBoundingClientRect();
  hytzMobileMenu.style.top = rect.bottom + 'px';
  hytzMobileMenu.style.left = '50%';
  hytzMobileMenu.style.width = rect.width + 'px';
}
function hytzOpenMobileMenu() {
  if (!hytzHamburger || !hytzMobileMenu) return;
  if (hytzCartDrawer && hytzCartDrawer.classList.contains('active')) hytzCloseCart();
  hytzHamburger.classList.add('active');
  hytzNav.classList.add('menu-open');
  hytzPositionMenu();
  hytzMobileMenu.style.display = 'block';
  requestAnimationFrame(function() {
    hytzMobileMenu.classList.add('active');
  });
  if (hytzMobileOverlay) hytzMobileOverlay.classList.add('active');
}
function hytzCloseMobileMenu() {
  if (!hytzHamburger || !hytzMobileMenu) return;
  hytzHamburger.classList.remove('active');
  hytzMobileMenu.classList.remove('active');
  hytzNav.classList.remove('menu-open');
  if (hytzMobileOverlay) hytzMobileOverlay.classList.remove('active');
  setTimeout(function() { hytzMobileMenu.style.display = 'none'; }, 300);
}

if (hytzHamburger && hytzMobileMenu) {
  hytzHamburger.addEventListener('click', function() {
    if (hytzMobileMenu.classList.contains('active')) {
      hytzCloseMobileMenu();
    } else {
      hytzOpenMobileMenu();
    }
  });
  if (hytzMobileOverlay) {
    hytzMobileOverlay.addEventListener('click', hytzCloseMobileMenu);
  }
  window.addEventListener('scroll', function() {
    if (hytzMobileMenu.classList.contains('active')) hytzPositionMenu();
  }, { passive: true });
  hytzMobileMenu.querySelectorAll('a').forEach(function(link) {
    link.addEventListener('click', hytzCloseMobileMenu);
  });
}

// Nav search toggle + live search — REMOVED. v2 nav has no search button.
// /search?q= is still accessible directly via URL; predictive search lives elsewhere.

// Scroll reveal
const hytzObserver = new IntersectionObserver(function(entries) {
  entries.forEach(function(e) {
    if (e.isIntersecting) {
      e.target.classList.add('visible');
      hytzObserver.unobserve(e.target);
    }
  });
}, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
document.querySelectorAll('.hytz-page .reveal').forEach(function(el) { hytzObserver.observe(el); });

// Modal image tab switching
document.addEventListener('click', function(e) {
  var tab = e.target.closest('.hytz-modal-img-tab');
  if (!tab) return;
  document.querySelectorAll('.hytz-modal-img-tab').forEach(function(t) { t.classList.remove('active'); });
  tab.classList.add('active');
  var size = tab.dataset.size;
  var imgEl = document.getElementById('hytz-modal-img');
  if (imgEl && window._hytzModalImages && window._hytzModalImages[size]) {
    imgEl.querySelector('img').src = window._hytzModalImages[size];
  }
});

// Modal accordions
document.querySelectorAll('.hytz-modal-accordion-btn').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var acc = btn.parentElement;
    var wasActive = acc.classList.contains('active');
    document.querySelectorAll('.hytz-modal-accordion.active').forEach(function(a) { a.classList.remove('active'); });
    if (!wasActive) acc.classList.add('active');
  });
});

// FAQ accordion
document.querySelectorAll('.hytz-faq-question').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var item = btn.parentElement;
    var wasActive = item.classList.contains('active');
    document.querySelectorAll('.hytz-faq-item.active').forEach(function(i) { i.classList.remove('active'); });
    if (!wasActive) item.classList.add('active');
  });
});

// Reviews marquee — drag to scroll with infinite loop
var hytzTrack = document.getElementById('hytz-marquee-track');
var hytzWrap = document.getElementById('hytz-marquee-wrap');
if (hytzTrack && hytzWrap) {
  var hytzDragging = false, hytzStartX, hytzDragOffset = 0, hytzBaseOffset = 0;
  var hytzHalfWidth = 0;

  function hytzGetHalfWidth() {
    hytzHalfWidth = hytzTrack.scrollWidth / 2;
  }

  function hytzSetOffset(offset) {
    // Wrap the offset so it loops
    if (hytzHalfWidth > 0) {
      offset = offset % hytzHalfWidth;
      if (offset > 0) offset -= hytzHalfWidth;
    }
    hytzDragOffset = offset;
    hytzTrack.style.transform = 'translateX(' + offset + 'px)';
  }

  // Pause CSS animation and switch to JS-driven position on first interaction
  var hytzAnimationStopped = false;
  function hytzStopAnimation() {
    if (hytzAnimationStopped) return;
    hytzAnimationStopped = true;
    // Get current computed transform position
    var style = getComputedStyle(hytzTrack);
    var matrix = new DOMMatrix(style.transform);
    hytzDragOffset = matrix.m41;
    hytzTrack.style.animation = 'none';
    hytzTrack.style.transform = 'translateX(' + hytzDragOffset + 'px)';
    hytzGetHalfWidth();
    // Start JS-based auto-scroll
    hytzAutoScroll();
  }

  var hytzAutoScrollRAF;
  var hytzAutoScrolling = true;
  function hytzAutoScroll() {
    if (!hytzAutoScrolling || hytzDragging) {
      hytzAutoScrollRAF = requestAnimationFrame(hytzAutoScroll);
      return;
    }
    hytzDragOffset -= 0.5; // pixels per frame
    if (hytzHalfWidth > 0 && hytzDragOffset <= -hytzHalfWidth) {
      hytzDragOffset += hytzHalfWidth;
    }
    hytzTrack.style.transform = 'translateX(' + hytzDragOffset + 'px)';
    hytzAutoScrollRAF = requestAnimationFrame(hytzAutoScroll);
  }

  // Mouse drag
  hytzWrap.addEventListener('mousedown', function(e) {
    hytzStopAnimation();
    hytzDragging = true;
    hytzStartX = e.pageX;
    hytzBaseOffset = hytzDragOffset;
    hytzTrack.style.cursor = 'grabbing';
  });
  window.addEventListener('mouseup', function() {
    if (!hytzDragging) return;
    hytzDragging = false;
    hytzTrack.style.cursor = 'grab';
  });
  window.addEventListener('mousemove', function(e) {
    if (!hytzDragging) return;
    e.preventDefault();
    var delta = e.pageX - hytzStartX;
    var newOffset = hytzBaseOffset + delta;
    if (hytzHalfWidth > 0) {
      newOffset = newOffset % hytzHalfWidth;
      if (newOffset > 0) newOffset -= hytzHalfWidth;
    }
    hytzDragOffset = newOffset;
    hytzTrack.style.transform = 'translateX(' + hytzDragOffset + 'px)';
  });

  // Touch drag
  hytzWrap.addEventListener('touchstart', function(e) {
    hytzStopAnimation();
    hytzDragging = true;
    hytzStartX = e.touches[0].pageX;
    hytzBaseOffset = hytzDragOffset;
  }, { passive: true });
  window.addEventListener('touchend', function() {
    hytzDragging = false;
  });
  window.addEventListener('touchmove', function(e) {
    if (!hytzDragging) return;
    var delta = e.touches[0].pageX - hytzStartX;
    var newOffset = hytzBaseOffset + delta;
    if (hytzHalfWidth > 0) {
      newOffset = newOffset % hytzHalfWidth;
      if (newOffset > 0) newOffset -= hytzHalfWidth;
    }
    hytzDragOffset = newOffset;
    hytzTrack.style.transform = 'translateX(' + hytzDragOffset + 'px)';
  }, { passive: true });
}

// Add to cart via Shopify Ajax API
function hytzAddToCart(variantId, btn) {
  if (!variantId) { console.error('HYTZ: no variantId'); return; }
  var originalText = btn ? btn.innerHTML : '';
  if (btn) btn.innerHTML = '✓';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
  })
  .then(function(res) {
    return res.json();
  })
  .then(function(data) {
    if (data.status) { console.error('HYTZ: cart error', data.description || data.message); }
    hytzRefreshCart();
    // If modal is open, show inline message instead of cart drawer
    if (hytzModal && hytzModal.classList.contains('active')) {
      var cartMsg = document.getElementById('hytz-modal-cart-msg');
      if (cartMsg) {
        cartMsg.textContent = '✓ Added to cart';
        cartMsg.classList.add('visible');
        setTimeout(function() { cartMsg.classList.remove('visible'); }, 2500);
      }
    } else {
      hytzOpenCart();
    }
    if (btn) setTimeout(function() { btn.innerHTML = originalText; }, 1200);
  })
  .catch(function(err) {
    console.error('HYTZ: fetch error', err);
    if (btn) { btn.innerHTML = originalText; }
  });
}

// Bind all add-to-cart clicks via delegation
document.addEventListener('click', function(e) {
  // Lineup row price buttons
  var priceBtn = e.target.closest('.hytz-lineup-row-price[data-variant-id]');
  if (priceBtn) {
    e.stopPropagation();
    e.preventDefault();
    hytzAddToCart(priceBtn.dataset.variantId, priceBtn.querySelector('.hytz-lineup-row-price-inner'));
    return;
  }
  // Modal price buttons
  var modalBtn = e.target.closest('.hytz-modal-price-pill[data-variant-id]');
  if (modalBtn) {
    e.stopPropagation();
    e.preventDefault();
    hytzAddToCart(modalBtn.dataset.variantId, modalBtn.querySelector('.hytz-modal-price-pill-inner'));
    return;
  }
});

// ── Cart Drawer ──
var hytzCartDrawer = document.getElementById('hytz-cart-drawer');
var hytzCartOverlay = document.getElementById('hytz-cart-overlay');

function hytzPositionCart() {
  if (!hytzCartDrawer || !hytzNav) return;
  var rect = hytzNav.getBoundingClientRect();
  hytzCartDrawer.style.top = rect.bottom + 'px';
  hytzCartDrawer.style.left = rect.left + 'px';
  hytzCartDrawer.style.width = rect.width + 'px';
  hytzCartDrawer.style.right = 'auto';
  hytzCartDrawer.style.maxHeight = 'calc(100vh - ' + (rect.bottom + 12) + 'px)';
}

function hytzOpenCart() {
  if (!hytzCartDrawer) return;
  if (hytzMobileMenu && hytzMobileMenu.classList.contains('active')) hytzCloseMobileMenu();
  if (hytzNav.classList.contains('search-open') && typeof hytzCloseSearch === 'function') hytzCloseSearch();
  hytzNav.classList.add('cart-open');
  hytzPositionCart();
  hytzCartDrawer.classList.add('active');
  hytzCartOverlay.classList.add('active');
}

function hytzCloseCart() {
  if (!hytzCartDrawer) return;
  hytzCartDrawer.classList.remove('active');
  hytzCartOverlay.classList.remove('active');
  hytzNav.classList.remove('cart-open');
}

window.hytzOpenCart = hytzOpenCart;
window.hytzCloseCart = hytzCloseCart;

// Close cart drawer
if (document.getElementById('hytz-cart-drawer-close')) {
  document.getElementById('hytz-cart-drawer-close').addEventListener('click', hytzCloseCart);
}
if (hytzCartOverlay) {
  hytzCartOverlay.addEventListener('click', hytzCloseCart);
}
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape' && hytzCartDrawer && hytzCartDrawer.classList.contains('active')) hytzCloseCart();
});

// Cart icon toggles drawer
document.querySelectorAll('.hytz-nav-icon[href="/cart"]').forEach(function(el) {
  el.addEventListener('click', function(e) {
    e.preventDefault();
    if (hytzCartDrawer && hytzCartDrawer.classList.contains('active')) {
      hytzCloseCart();
    } else {
      hytzOpenCart();
    }
  });
});

// Re-render cart drawer body via fetch
function hytzRefreshCart() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      // Update all cart counts
      document.querySelectorAll('.hytz-cart-count').forEach(function(el) { el.textContent = cart.item_count; });
      document.querySelectorAll('.hytz-cart-drawer-count').forEach(function(el) { el.textContent = '(' + cart.item_count + ')'; });

      var body = document.getElementById('hytz-cart-drawer-body');
      var footer = document.getElementById('hytz-cart-drawer-footer');
      var meter = document.getElementById('hytz-cart-drawer-meter');

      // Shipping meter — update independent of items/footer
      if (meter) {
        var thresholdCents = 2500;
        var cartCents = cart.total_price;
        var remaining = Math.max(0, thresholdCents - cartCents);
        var pct = thresholdCents > 0 ? Math.min(100, Math.floor(cartCents * 100 / thresholdCents)) : 0;
        meter.classList.toggle('is-unlocked', remaining === 0 && cartCents > 0);
        var msg;
        if (remaining === 0 && cartCents > 0) {
          msg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>Free shipping unlocked';
        } else if (cartCents === 0) {
          msg = 'Free shipping over $' + (thresholdCents / 100).toFixed(0);
        } else {
          msg = '<strong>$' + (remaining / 100).toFixed(2) + '</strong> away from free shipping';
        }
        meter.innerHTML =
          '<div class="hytz-cart-meter-msg">' + msg + '</div>' +
          '<div class="hytz-cart-meter-bar-row">' +
            '<div class="hytz-cart-meter-track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '">' +
              '<div class="hytz-cart-meter-fill" style="width: ' + pct + '%;"></div>' +
            '</div>' +
            '<span class="hytz-cart-meter-threshold">$' + (thresholdCents / 100).toFixed(0) + '</span>' +
          '</div>';
      }

      if (cart.item_count === 0) {
        // Empty state — render 3 mini lineup rows with data-handle (flip-modal triggers).
        // Asset base for bag images comes from window.hytzAssetBase if present, else relative.
        var base = window.hytzAssetBase || '';
        var rows = [
          { h: 'sauce-shield', name: 'Sauce Shield', price: '$4.99', pc: '#95192d', bag: 'sauce-shield-bag-front.png' },
          { h: 'lung-hero',    name: 'Lung Hero',    price: '$4.99', pc: '#4cb968', bag: 'lung-hero-bag-front.png' },
          { h: 'the-nod',      name: 'The Nod',      price: '$4.99', pc: '#764099', bag: 'the-nod-bag-front.png' }
        ];
        var eh = '<div class="hytz-cart-empty">' +
          '<p class="hytz-cart-empty-kicker">Cart\'s empty — here\'s what you\'re missing:</p>' +
          '<div class="hytz-cart-empty-lineup">';
        rows.forEach(function (r) {
          eh += '<div class="hytz-cart-empty-row" data-handle="' + r.h + '" role="button" tabindex="0" aria-label="Quick view ' + r.name + '" style="--c:' + r.pc + '">' +
            '<div class="hytz-cart-empty-row-img"><img src="' + base + r.bag + '" alt="' + r.name + '" loading="lazy"></div>' +
            '<div class="hytz-cart-empty-row-info">' +
              '<div class="hytz-cart-empty-row-name">' + r.name + '</div>' +
              '<div class="hytz-cart-empty-row-price">From ' + r.price + '</div>' +
            '</div>' +
            '<div class="hytz-cart-empty-row-arrow" aria-hidden="true">→</div>' +
          '</div>';
        });
        eh += '</div>' +
          '<a href="/collections/the-lineup" class="hytz-cart-empty-viewall">See all 6 formulas →</a>' +
        '</div>';
        body.innerHTML = eh;
        footer.innerHTML = '';
        return;
      }

      var html = '';
      cart.items.forEach(function(item, i) {
        var imgHtml = item.image ? '<img src="' + item.image.replace(/(\.[^.]+)$/, '_120x$1') + '" alt="' + item.product_title + '">' : '';
        var unitPrice = '$' + (item.price / 100).toFixed(2);
        html += '<div class="hytz-cart-item" data-line="' + (i + 1) + '">';
        html += '<div class="hytz-cart-item-img">' + imgHtml + '</div>';
        var lineTotal = '$' + (item.final_line_price / 100).toFixed(2);
        html += '<div class="hytz-cart-item-info">';
        html += '<div class="hytz-cart-item-name">' + item.product_title + '</div>';
        html += '<div class="hytz-cart-item-unit-price">' + item.variant_title + ' &middot; ' + unitPrice + ' ea</div>';
        html += '<div class="hytz-cart-item-qty">';
        html += '<button class="hytz-cart-qty-btn" data-action="minus" data-line="' + (i + 1) + '">−</button>';
        html += '<span class="hytz-cart-qty-val">' + item.quantity + '</span>';
        html += '<button class="hytz-cart-qty-btn" data-action="plus" data-line="' + (i + 1) + '">+</button>';
        html += '</div>';
        html += '</div>';
        html += '<span class="hytz-cart-item-line-total">' + lineTotal + '</span>';
        html += '<button class="hytz-cart-item-remove" data-line="' + (i + 1) + '" aria-label="Remove"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>';
        html += '</div>';
      });
      body.innerHTML = html;

      var totalStr = '$' + (cart.total_price / 100).toFixed(2);

      // Cart-level discount rows (any auto-applied or promo-applied codes)
      var discountRows = '';
      if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
        cart.cart_level_discount_applications.forEach(function(d) {
          var amt = '−$' + ((d.total_allocated_amount || 0) / 100).toFixed(2);
          discountRows += '<div class="hytz-cart-discount-row">' +
            '<span class="hytz-cart-discount-label"><span class="hytz-cart-discount-code">' + (d.title || 'Discount') + '</span> applied</span>' +
            '<span class="hytz-cart-discount-amt">' + amt + '</span>' +
          '</div>';
        });
      }

      footer.innerHTML =
        '<details class="hytz-cart-promo">' +
          '<summary class="hytz-cart-promo-summary">' +
            '<span>Have a promo code?</span>' +
            '<svg class="hytz-cart-promo-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>' +
          '</summary>' +
          '<div class="hytz-cart-promo-body">' +
            '<input type="text" class="hytz-cart-promo-input" id="hytz-drawer-promo-input" placeholder="Enter code" autocomplete="off" spellcheck="false">' +
            '<button type="button" class="hytz-cart-promo-apply" data-hy-drawer-promo>Apply</button>' +
          '</div>' +
        '</details>' +
        discountRows +
        '<div class="hytz-cart-subtotal"><span>Subtotal</span><span>' + totalStr + '</span></div>' +
        '<a href="/checkout" class="hytz-cart-checkout-btn hy-btn hy-btn-primary">' +
          'Checkout' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>' +
        '</a>' +
        '<div class="hytz-cart-trust-row">' +
          '<span class="hytz-cart-trust-item">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.77 5.82 22 7 14.14l-5-4.87 6.91-1.01L12 2z"/></svg>' +
            '3rd-party tested' +
          '</span>' +
          '<span class="hytz-cart-trust-dot" aria-hidden="true">·</span>' +
          '<span class="hytz-cart-trust-item">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 01-2 2H7a2 2 0 01-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 010-5C10 3 12 8 12 8s2-5 4.5-5a2.5 2.5 0 010 5"/></svg>' +
            'Discreet packaging' +
          '</span>' +
          '<span class="hytz-cart-trust-dot" aria-hidden="true">·</span>' +
          '<span class="hytz-cart-trust-item">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22s-8-4.5-8-11.5A5.5 5.5 0 0112 5a5.5 5.5 0 018 5.5c0 7-8 11.5-8 11.5z"/></svg>' +
            '30-day guarantee' +
          '</span>' +
        '</div>';

      hytzBindCartActions();
      hytzBindDrawerPromo();
    });
}

// Apply promo code via cart.js (in-place, no page reload)
function hytzApplyDiscount(code) {
  if (!code) return Promise.resolve(false);
  code = String(code).trim();
  if (!code) return Promise.resolve(false);
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ discount: code })
  }).then(function(r) {
    if (!r.ok) return false;
    if (typeof hytzRefreshCart === 'function') hytzRefreshCart();
    return true;
  }).catch(function() { return false; });
}

function hytzBindDrawerPromo() {
  var btn = document.querySelector('[data-hy-drawer-promo]');
  if (!btn || btn.dataset.hyBound) return;
  btn.dataset.hyBound = '1';
  function apply() {
    var input = document.getElementById('hytz-drawer-promo-input');
    if (!input) return;
    var code = (input.value || '').trim();
    if (!code) { input.focus(); return; }
    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = 'Applying…';
    hytzApplyDiscount(code).then(function(ok) {
      btn.disabled = false;
      btn.textContent = orig;
      if (ok) { input.value = ''; }
      else { input.focus(); }
    });
  }
  btn.addEventListener('click', apply);
  var input = document.getElementById('hytz-drawer-promo-input');
  if (input) {
    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); apply(); }
    });
  }
}

// On page load, auto-apply ?discount= from URL (silent)
(function hytzAutoApplyUrlDiscount() {
  try {
    var params = new URLSearchParams(window.location.search);
    var code = params.get('discount');
    if (!code) return;
    hytzApplyDiscount(code);
  } catch (e) {}
})();

// Bind qty +/- and remove buttons
function hytzBindCartActions() {
  document.querySelectorAll('.hytz-cart-qty-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var line = parseInt(btn.dataset.line);
      var action = btn.dataset.action;
      var qtyEl = btn.parentElement.querySelector('.hytz-cart-qty-val');
      var qty = parseInt(qtyEl.textContent);
      var newQty = action === 'plus' ? qty + 1 : qty - 1;
      if (newQty < 0) newQty = 0;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: newQty })
      }).then(function() { hytzRefreshCart(); });
    });
  });

  document.querySelectorAll('.hytz-cart-item-remove').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var line = parseInt(btn.dataset.line);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      }).then(function() { hytzRefreshCart(); });
    });
  });
}

// Initial bind for server-rendered cart items
hytzBindCartActions();
hytzBindDrawerPromo();

// Close cart when clicking any link inside it
if (hytzCartDrawer) {
  hytzCartDrawer.addEventListener('click', function(e) {
    var link = e.target.closest('a[href]');
    if (link && !link.closest('.hytz-cart-qty-btn') && !link.closest('.hytz-cart-item-remove')) {
      hytzCloseCart();
    }
  });
}
